import React, { FC } from 'react';
import useTranslation from '../../../hooks/useTranslation';
import CustomMultilineInput from '../../../common/CustomMultilineInput';
import CustomSelect from '../../../common/CustomSelect';
import { getOptionsFromTranslation } from '../../../utils/utils';

const ProjectInformationFields: FC = () => {
  const t = useTranslation();
  return (
    <>
      <CustomMultilineInput
        dataTestID={'project-background'}
        name={'additionalProjectInformation'}
        label={t('labels.projectBg')}
      />
      <CustomMultilineInput
        dataTestID={'solution-description-and-cost'}
        name={'solutionDescriptionAndCost'}
        label={t('labels.solutionDescriptionAndCost')}
      />
      <CustomMultilineInput
        dataTestID={'estimated-return'}
        name={'benefitsAndRisk'}
        label={t('labels.estimatedReturn')}
      />
      <CustomSelect
        dataTestID={'project-prioritisation'}
        optionsArray={getOptionsFromTranslation(t, 'projectPrioritization')}
        name={'etrProjectPrioritization'}
        label={t('labels.projectPrioritisation')}
        disableOnAll={false}
      />
    </>
  );
};

export default ProjectInformationFields;
